import { Component } from '@angular/core';
import { UtilService } from '../../shared/services/util.service';
import { ApiService } from '../../shared/services/api.service';

@Component({
  standalone: false,
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {

  fromDate: any;
  toDate: any;
  minToDate: any;

  constructor(private _util: UtilService, private _api: ApiService) {

  }

  reportData: any = null;
  reportKeys: string[] = [];
  reportRows: any[][] = [];
  errorMessage: string = '';

  onSubmit() {
    const vm = this;
    vm.reportData = null;
    vm.reportKeys = [];
    vm.reportRows = [];
    vm.errorMessage = '';
    const fromEpoch = vm.fromDate?.year ? new Date(vm.fromDate.year, vm.fromDate.month - 1, vm.fromDate.day).getTime() : null;
    const toEpoch = vm.toDate?.year ? new Date(vm.toDate.year, vm.toDate.month - 1, vm.toDate.day).getTime() : null;
    if (!fromEpoch || !toEpoch) return;
    vm._api.getData(`/admin/report?from=${fromEpoch}&to=${toEpoch}`).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          vm.reportData = res;
          if (res.data && res.data.length > 0) {
            vm.reportKeys = Object.keys(res.data[0]);
            vm.reportRows = res.data.map((row: any) => vm.reportKeys.map((k: string) => row[k]));
          }
        } else {
          vm.errorMessage = res.message || 'Failed to generate report';
        }
      },
      error: (err: any) => {
        vm.errorMessage = (err.error && err.error.message) || err.message || 'Failed to generate report';
      }
    });
  }

  onFromDate(event) {
    const vm = this;
    vm.minToDate = vm._util.getMinFormat(event);
  }


}
